export default __webpack_public_path__ + "static/scribble_background-58d92b59c33e198d851f6915fc886f99.png";